<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="isDrawerOpen"
      temporary
      width="220"
      app
      dark
      class="primary"
    >
      <v-list-tile>
        <v-spacer />
        <v-btn
          icon
          @click="isDrawerOpen = !isDrawerOpen"
        >
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
      </v-list-tile>
      <admin-menu v-if="isAdmin" />
      <user-menu v-else />
    </v-navigation-drawer>
    <v-toolbar
      fixed
      app
      color="light"
      extended
      extension-height="7"
    >
      <v-toolbar-side-icon
        v-if="user.active"
        @click.stop="isDrawerOpen = !isDrawerOpen"
      />
      <v-toolbar-title class="align-center">
        <router-link :to="{ name: 'dashboard' }">
          <img
            src="../../public/logo_valacon.svg"
            class="logo"
          >
        </router-link>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items class="subheading align-center text-xs-right">
        {{ user | fullName }}<br>
        {{ user.email }}
        <v-menu
          open-on-hover
          bottom
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn
              light
              icon
              v-on="on"
            >
              <v-icon>fa-caret-down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile :to="{ name: 'profile' }">
              <v-list-tile-action>
                <v-icon>fa-user</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ $t('message.profile') }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-action>
                <v-icon>fa-sign-out-alt</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ $t('message.logout') }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-progress-linear
        v-if="$store.state.loading"
        slot="extension"
        indeterminate
        class="ma-0"
      />
    </v-toolbar>
    <v-content>
      <v-container
        fluid
        grid-list-md
      >
        <slot />
      </v-container>
    </v-content>
    <v-footer color="lower">
      <v-layout column>
        <div class="white--text">
          Valacon &copy; {{ new Date().getFullYear() }}
        </div>
      </v-layout>
    </v-footer>
    <v-dialog
      v-if="!isAdmin && !user.agree_gdpr && user.active"
      v-model="showGdprDialog"
      persistent
      width="95%"
    >
      <gdpr-dialog
        @confirm="agreeWithGdpr"
        @decline="declineGdpr"
      />
    </v-dialog>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import UserMenu from '../components/UserMenu.vue'
import AdminMenu from '../components/AdminMenu.vue'
import GdprDialog from '../components/admin/GdprDialog.vue'

export default {
  name: 'AppLayout',
  components: {
    UserMenu,
    AdminMenu,
    GdprDialog,
  },
  data: () => ({
    icon: '',
    showGdprDialog: true,
  }),
  computed: {
    isAdmin() {
      return this.user.isAdmin
    },
    isDrawerOpen: {
      get: function () {
        return this.$store.state.isDrawerOpen
      },
      set: function (value) {
        this.$store.commit('isDrawerOpen', value)
      },
    },
    ...mapState(['user']),
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
      case 'logout':
        this.$router.push({ name: 'login' })
        break
      }
    })
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
    },
    declineGdpr() {
      this.logout()
    },
    agreeWithGdpr(receiveNotifications) {
      this.showGdprDialog = false

      const userCopy = JSON.parse(JSON.stringify(this.user))
      userCopy.agree_gdpr = true
      userCopy.agree_gdpr_notifications_email = receiveNotifications
      delete userCopy.role
      this.$store.dispatch('updateUserProfile', userCopy)
    },
  },
}
</script>
<style>
.primary.v-navigation-drawer > div:first-child .v-list__tile {
  padding: 0;
}
footer .v-progress-linear {
  margin: 0;
}
#app {
  text-align: left;
}
.logo {
  width: 250px;
  margin-top: 15px;
}
.v-toolbar__content .theme--light.v-btn--icon {
  color: rgba(0, 0, 0, 0.5);
}

.v-list__tile--active {
  background-color: white !important;
}
</style>
